import { useRef, useEffect, useMemo } from 'react';
import { DotMap, DotMapOptionArg } from '@dot-map-renderer/app';
import { LineData } from '@dot-map-renderer/component/src/line/LineData';
import { Point } from '@dot-map-renderer/component';
import React from 'react';

type Props = {
    anchors: Point[],
    lines: LineData[],
    options?: DotMapOptionArg,
} & Pick<React.ComponentProps<'div'>,
    'style' |
    'className'
    >;

function ReactDotMap({
    anchors,
    lines,
    options,
    style,
    className
}: Props)
{
    const ref = useRef<HTMLDivElement>(null);
    const dotMap = useMemo(() =>
    {
        if(!ref.current){
            return null;
        }
        if(dotMap){
            dotMap.detach();
        }

        const map = new DotMap(options);

        map.attach(ref.current!);

        return map;
    }, [options]);

    const controller = useMemo(() =>
        dotMap?.getController(), [dotMap]);

    useEffect(() =>
    {
        if (!controller)
        {
            return;
        }

        lines.forEach((line) =>
        {
            controller.addLine(line);
        });

        anchors.forEach((anchor) =>
        {
            controller.addAnchor(anchor);
        });
    }, [controller, lines, anchors]);

    return <div
        ref={ref}
        style={style}
        className={className}
    />;
}

export default ReactDotMap;
